import {
  SET_ALL_BOARDS,
  DELETE_BOARD,
  ADD_NEW_BOARD,
  UPDATE_BOARD,
  SET_SINGLE_BOARD,
  DELETE_TASK,
  ADD_TASK,
  UPDATE_TASK,
  ARCHIVE_TASK,
  UNARCHIVE_TASK,
  SET_ALL_COMMENTS,
  ADD_COMMENT,
  SET_TASK_SORTING,
  UPDATE_COMMENT,
  DELETE_COMMENT,
  ADD_REPLY,
  UPDATE_REPLY,
  DELETE_REPLY,
  SET_SINGLE_BOARD_FROM_STORE,
  UPDATE_PURPOSE,
} from "../types";
import { setExpiry } from "../../common";

const initialState = {
  myBoardsList: [],
  sharedBoardsList: [],
  singleBoard: null,
  prev_boardId: null,
  allBoardsDetails: {},
  commentsList: [],
};

// handle actions
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_ALL_BOARDS: {
      setExpiry("sustainchange_all_boards_expiry");
      return {
        ...state,
        myBoardsList: payload.my_boards,
        sharedBoardsList: payload.shared_boards,
      };
    }
    case DELETE_BOARD: {
      let boards = [...state.myBoardsList];
      boards = boards.filter((item) => item.id !== payload);
      return {
        ...state,
        myBoardsList: boards,
      };
    }
    case ADD_NEW_BOARD: {
      let boards = [payload, ...state.myBoardsList];
      return {
        ...state,
        myBoardsList: boards,
      };
    }
    case UPDATE_BOARD: {
      let _boards = [...state.myBoardsList];
      let index = _boards.findIndex((item) => item.id === payload.id);
      _boards[index] = { ...payload };
      return {
        ...state,
        myBoardsList: [..._boards],
      };
    }
    case SET_SINGLE_BOARD: {
      setExpiry(`sustainchange_single_board_expiry_${payload.board.id}`);
      let associated_users = [];

      if (payload.board?.associated_users) {
        associated_users = [...payload.board?.associated_users];
      }

      let _board = { ...payload.board };
      let columnOrder = _board.tasklists;
      let _taskIds = [];
      let _columns = {};
      let _id;
      let _archived = [];
      let _tasks = {};
      columnOrder.forEach((element) => {
        _taskIds = [];
        _archived = [];
        _tasks = {};
        _id = element.tasklist_id;
        element["id"] = element.tasklist_id;
        element["title"] = element.tasklist_title;
        let _taskKeys = Object.keys(element.tasks);
        if (_taskKeys) {
          _taskKeys.map((item) => {
            if (element.tasks[item].post_status === "publish") {
              _taskIds.push(element.tasks[item].id);
            } else {
              _archived.push(element.tasks[item].id);
            }
            _tasks[element.tasks[item].id] = { ...element.tasks[item] };

            return "";
          });
        }

        element["taskIds"] = _taskIds;
        element["tasks"] = _tasks;
        element["archived"] = _archived;
        _columns[_id] = element;
      });

      let _allBoardsDetails = { ...state.allBoardsDetails };

      _allBoardsDetails[_board.id] = {
        title: _board.title,
        columnOrder,
        columns: _columns,
        associated_users,
        purpose: _board.purpose,
        chart: _board.board_chart
      };

      return {
        ...state,
        singleBoard: {
          id: _board.id,
          title: _board.title,
          columnOrder,
          columns: _columns,
          associated_users,
          purpose: _board.purpose,
          chart: _board.board_chart
        },
        allBoardsDetails: { ..._allBoardsDetails },
        prev_boardId: payload.id,
      };
    }

    case UPDATE_PURPOSE: {
      let _allBoardsDetails = { ...state.allBoardsDetails };

      _allBoardsDetails[payload.boardId] = {
        ..._allBoardsDetails[payload.boardId],
        purpose: payload.purpose,
      };

      let _columnsData = { ...state.singleBoard };
      _columnsData.purpose = payload.purpose;
      const _board = {
        ..._columnsData,
      };
      const b = {
        ...state,
        singleBoard: _board,
        allBoardsDetails: { ..._allBoardsDetails },
      };

      return b;
    }

    case SET_SINGLE_BOARD_FROM_STORE: {
      return { ...state, singleBoard: payload };
    }
    case DELETE_TASK: {
      let _columnsData = { ...state.singleBoard };
      let _column = _columnsData?.columns[payload.column];
      if (payload.post_status === "archive") {
        let _archived = _columnsData?.columns[payload.column]?.archived.filter(
          (item) => parseInt(item) !== parseInt(payload.task)
        );
        if (_column) {
          _column.archived = _archived;
        }
      } else {
        let _tasksIds = _columnsData?.columns[payload.column]?.taskIds.filter(
          (item) => parseInt(item) !== parseInt(payload.task)
        );
        if (_column) {
          _column.taskIds = _tasksIds;
        }
      }
      _columnsData.columns[payload.column] = _column;

      let _board = {
        ..._columnsData,
      };
      return {
        ...state,
        singleBoard: _board,
      };
    }

    case ADD_TASK: {
      const { task, column } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[column]?.tasks;
      _tasks[task.id] = { ...task };
      let _columnTasks = _columnsData?.columns[column]?.taskIds;
      _columnTasks = [task.id, ..._columnTasks];
      _columnsData.columns[column].taskIds = [..._columnTasks];
      const _board = {
        ..._columnsData,
        tasks: _tasks,
      };
      return {
        ...state,
        singleBoard: _board,
      };
    }

    case UPDATE_TASK: {
      const { task, column } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[column]?.tasks;
      _tasks[task.id] = { ...task };
      let _column = _columnsData?.columns[column];
      if (_column) {
        _column.tasks = { ..._tasks };
      }
      _columnsData.columns[column] = _column;
      const _board = {
        ..._columnsData,
      };
      return {
        ...state,
        singleBoard: _board,
      };
    }
    case ARCHIVE_TASK: {
      const { task, column } = payload;
      let _columnsData = { ...state.singleBoard };

      let _tasksIds = _columnsData?.columns[column]?.taskIds.filter(
        (item) => parseInt(item) !== parseInt(task.id)
      );
      let _archived = [
        `${task.id}`,
        ..._columnsData?.columns[column]?.archived,
      ];

      let _tasks = _columnsData?.columns[column]?.tasks;

      _tasks[task.id] = { ...task };

      let _column = _columnsData?.columns[column];
      if (_column) {
        _column.taskIds = _tasksIds;
        _column.archived = _archived;
        _column.tasks = { ..._tasks };
      }

      _columnsData.columns[column] = _column;
      const _board = {
        ..._columnsData,
      };

      return {
        ...state,
        singleBoard: _board,
      };
    }
    case UNARCHIVE_TASK: {
      const { task, column } = payload;
      let _columnsData = { ...state.singleBoard };

      let _archived = _columnsData?.columns[column]?.archived.filter(
        (item) => parseInt(item) !== parseInt(task.id)
      );
      let _tasksIds = [`${task.id}`, ..._columnsData?.columns[column]?.taskIds];

      let _tasks = _columnsData?.columns[column]?.tasks;

      _tasks[task.id] = { ...task };

      let _column = _columnsData?.columns[column];
      if (_column) {
        _column.taskIds = _tasksIds;
        _column.archived = _archived;
        _column.tasks = { ..._tasks };
      }

      _columnsData.columns[column] = _column;
      const _board = {
        ..._columnsData,
      };

      return {
        ...state,
        singleBoard: _board,
      };
    }
    case SET_ALL_COMMENTS: {
      const { taskId, listId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;

      return {
        ...state,
        commentsList: allComments,
      };
    }
    case SET_TASK_SORTING: {
      const { data } = payload;

      return {
        ...state,
        singleBoard: data,
      };
    }
    case ADD_COMMENT: {
      const { comment, taskId, listId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;
      _tasks[taskId].comments = [comment, ...allComments];
      _columnsData.columns[listId].tasks = { ..._tasks };
      return {
        ...state,
        singleBoard: _columnsData,
      };
    }
    case UPDATE_COMMENT: {
      const { comment, taskId, listId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;
      let index = allComments.findIndex(
        (item) => parseInt(item.comment_id) === parseInt(comment.comment_id)
      );
      if (index > -1) {
        allComments[index] = { ...comment };
      }
      _tasks[taskId].comments = [...allComments];
      _columnsData.columns[listId].tasks = { ..._tasks };
      return {
        ...state,
        singleBoard: _columnsData,
      };
    }
    case DELETE_COMMENT: {
      const { comment, taskId, listId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;
      allComments = allComments.filter(
        (item) => parseInt(item.comment_id) !== parseInt(comment.comment_id)
      );
      _tasks[taskId].comments = [...allComments];
      _columnsData.columns[listId].tasks = { ..._tasks };
      return {
        ...state,
        singleBoard: _columnsData,
      };
    }

    case ADD_REPLY: {
      const { comment, taskId, listId, commentId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;
      let index = allComments.findIndex(
        (item) => parseInt(item.comment_id) === parseInt(commentId)
      );

      if (index > -1) {
        let allReplies = _tasks[taskId].comments[index].children;
        _tasks[taskId].comments[index].children = [comment, ...allReplies];
        _columnsData.columns[listId].tasks = { ..._tasks };
      }

      return {
        ...state,
        singleBoard: _columnsData,
      };
    }

    case UPDATE_REPLY: {
      const { comment, taskId, listId, commentId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;

      let index = allComments.findIndex(
        (item) => parseInt(item.comment_id) === parseInt(commentId)
      );
      if (index > -1) {
        let allReplies = _tasks[taskId].comments[index].children;
        let _index = allReplies.findIndex(
          (item) => parseInt(item.comment_id) === parseInt(comment.comment_id)
        );
        if (_index > -1) {
          allReplies[index] = { ...comment };
        }

        _tasks[taskId].comments[index].children = [...allReplies];
        _columnsData.columns[listId].tasks = { ..._tasks };
      }
      return {
        ...state,
        singleBoard: _columnsData,
      };
    }

    case DELETE_REPLY: {
      const { comment, taskId, listId, commentId } = payload;
      let _columnsData = { ...state.singleBoard };
      let _tasks = _columnsData?.columns[listId]?.tasks;
      let allComments = _tasks[taskId].comments;
      let index = allComments.findIndex(
        (item) => parseInt(item.comment_id) === parseInt(commentId)
      );

      if (index > -1) {
        let allReplies = _tasks[taskId].comments[index].children;
        allReplies = allReplies.filter(
          (item) => parseInt(item.comment_id) !== parseInt(comment.comment_id)
        );

        _tasks[taskId].comments[index].children = [...allReplies];
        _columnsData.columns[listId].tasks = { ..._tasks };
      }

      return {
        ...state,
        singleBoard: _columnsData,
      };
    }
    default:
      return state;
  }
}
